var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.notification,"color":_vm.color,"top":_vm.top}},[_vm._v(_vm._s(_vm.notificationText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }